<template>
    <div>
        <Form ref="formItem" :label-width="80" :model="formItem" :rules="ruleInline">
            <Form-item label="标题" prop="title">
                <Input type="text" v-model="formItem.title"></Input>
            </Form-item>
            <Form-item label="开始时间" prop="str_sdate">
                <Date-picker type="datetime" style="width:100%" placeholder="选择日期和时间" :options="dataOption" @on-change="formItem.str_sdate=$event"></Date-picker>
            </Form-item>
            <Form-item label="结束时间" prop="str_edate">
                <Date-picker type="datetime" style="width:100%" placeholder="选择日期和时间" :options="dataOption" @on-change="formItem.str_edate=$event"></Date-picker>
            </Form-item>
            <Form-item label="H5链接" prop="url">
                <Input type="text" v-model="formItem.url"></Input>
            </Form-item>
            <Form-item label="内容" prop="content">
                <Input type="textarea" v-model="formItem.content"></Input>
            </Form-item>
            <Form-item>
                <Button type="primary" @click="submitFn('formItem')">提交</Button>
            </Form-item>
        </Form>
        <el-dialog title="提交" :visible.sync="addShow">
            <p>确认要提交？</p>
            <div slot="footer" class="dialog-footer">
                <Button @click="addShow=false">取 消</Button>
                <Button type="primary" @click="axiosFn">确 定</Button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
	export default{
		data(){
			const urlRegexp = (rule, value, callback) => {
                if(value == '' || value == null){
                    callback();
                }else{
                    if(!/^http|https?:\/\/(([a-zA-Z0-9_-])+(\.)?)*(:\d+)?(\/((\.)?(\?)?=?&?[a-zA-Z0-9_-](\?)?)*)*$/i.test(value)){
                        callback(new Error('链接格式不对'));
                    }else{
                        callback();
                    }
                }
			};
			return {
				formItem:{
					title:null,
					url:null,
					str_sdate:null,
					str_edate:null,
                    content:null
				},
                type:0,
                addShow:false,
				ruleInline: {
                    title: [
                        { required: true, message: '活动名称不能为空', trigger: 'change' }
                    ],
                    url: [
                        { required: false, validator: urlRegexp, trigger: 'change' }
                    ],
                    str_sdate: [
                        { required: true, message: '开始时间不能为空', trigger: 'change' },
                    ],
                    str_edate: [
                        { required: true, message: '结束时间不能为空', trigger: 'change' },
                    ],
                    content: [
                        { required: true, message: '内容不能为空', trigger: 'change' },
                    ]
                },
                dataOption:{
                    disabledDate (date) {
                        return date && date.valueOf() < Date.now() - 86400000;
                    }
                }
			}
		},
		created(){
			this.$store.dispatch('parent2ShowFn');
		},
		methods:{
			submitFn(name){
				var _this=this;
				_this.$refs[name].validate((valid) => {
                    if (valid) {
                    	_this.addShow=true;
                    } else {
                        _this.$Message.error('表单验证失败!');
                    }
                })
			},
            axiosFn(){
                this.addShow=false;
                var _this=this;
                _this.$http.post('/web/broadCast/addBroadCast',_this.formItem).then(function(res){
                    if(res.success){
                        _this.$Notice.success({
                            title: '发布推送',
                            desc: res.message,
                        });
                        _this.$router.push({path:'/pushNews'});
                    }else{
                        _this.$Notice.error({
                            title: '发布推送',
                            desc: res.message,
                        });
                    }
                }).catch(function(res){
                    _this.$Notice.error({
                        title: '发布推送',
                        desc: '发布失败',
                    });
                })
            },
		}
	}
</script>
<style scoped>
	
</style>


// WEBPACK FOOTER //
// src/components/push/addNews.vue